<main class="login-page">
	<section class="login-card">
		<header>
			<!-- <span class="login-mark">P</span> -->
			<img src="/assets/logo_black.png" alt="" style="max-width: 8rem" />

			<div>
				<span class="eyebrow">Operator</span>
				<!-- <h1>{{ challenge() ? 'Επιλογή καταστήματος' : 'Login' }}</h1> -->
				<h1 style="font-weight: 700; font-size: 1.9rem;">Login</h1>
			</div>
		</header>
		@if (!challenge()) {
			<form [formGroup]="pinForm" (ngSubmit)="login()">
				<label>
					<span>PIN</span>
					<input
						inputmode="numeric"
						type="password"
						formControlName="pin"
						autocomplete="off"
						placeholder="••••"
					/>
				</label>
				<button [disabled]="pinForm.invalid || busy()">
					{{ busy() ? 'Σύνδεση…' : 'Σύνδεση' }}
				</button>
			</form>
		} @else {
			<form [formGroup]="storeForm" (ngSubmit)="continue()">
				<label>
					<span>Επιλογή καταστήματος</span>
					<select formControlName="storeId">
						@for (store of challenge()!.stores; track store.id) {
							<option [value]="store.id">{{ store.name }}</option>
						}
					</select>
				</label>
				<button [disabled]="storeForm.invalid || busy()">
					{{ busy() ? 'Έναρξη…' : 'Έναρξη βάρδιας' }}
				</button>
			</form>
		}
	</section>
</main>
